import * as React from 'react';
import { CurrencyInput } from '../parts/NumberInput';
import { SpendAmountsModel } from '../../data/dataStore';
import { TheBrain } from '../../data/brain';
import { currencyFormat } from '../../helpers';

export interface WhatProps {
    data: SpendAmountsModel;
    onChanged: (m: SpendAmountsModel) => void;
    brain: TheBrain;
}


export const What = (props: WhatProps) => {

    const { data, onChanged, brain } = props;

    const renderFieldRow = (title: string, v: number, fun: (p: SpendAmountsModel, v: number) => void) =>
        <>
            <label>{title}</label>
            <CurrencyInput
                value={v}
                onValueChange={v => {
                    const dd = { ...data };
                    const vv = v;
                    fun(dd, vv);
                    onChanged(dd);
                }}
            // x={44}
            />
        </>



    return <div className="what">
        <div className="beeom-form">
            {renderFieldRow("Recording", data.recording, (p, v) => p.recording = v)}
            {renderFieldRow("Marketing/Promo", data.marketing, (p, v) => p.marketing = v)}
            {renderFieldRow("Manufacturing", data.manufacturing, (p, v) => p.manufacturing = v)}
            {renderFieldRow("Admin", data.admin, (p, v) => p.admin = v)}
            {renderFieldRow("Anything else?", data.other, (p, v) => p.other = v)}
            {/* <div className="form-total"> */}
            <div></div><div></div>             {/* spacer */}
            <div></div><div></div>             {/* spacer */}
            <span className="header">TOTAL</span>
            <span className="total">{currencyFormat(brain.getTotalSpend())}</span>
            {/* </div> */}
        </div>
    </div>

}